import { render, staticRenderFns } from "./CreateTestuser.vue?vue&type=template&id=148e755e&"
import script from "./CreateTestuser.vue?vue&type=script&lang=js&"
export * from "./CreateTestuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports